<div class="flex flex-col justify-between flex-auto items-center">

    <!-- Logo -->
    <app-startup-logo></app-startup-logo>

    <div class="start-up-form-container">

        <!-- Title -->
        <div class="start-up-title"> New password </div>
 
        <!-- Alert -->
        @if (showAlert) {
            <fuse-alert
                class="mt-2"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'"
            >
                {{ alert.message }}
            </fuse-alert>
        }

        <!-- Reset password form -->
        <form
            class="mt-3"
            [formGroup]="resetPasswordForm"
            #resetPasswordNgForm="ngForm"
        >
            <!-- Password field -->
            <mat-form-field class="mat-form-field-cleaner">
                <mat-label class="font-bold text-md">Password</mat-label>
                <input
                    class="input"
                    id="password"
                    matInput
                    type="password"
                    [formControlName]="'password'"
                    #passwordField
                />
                <!-- <button
                    mat-icon-button
                    type="button"
                    (click)="
                        passwordField.type === 'password'
                            ? (passwordField.type = 'text')
                            : (passwordField.type = 'password')
                    "
                    matSuffix
                >
                    @if (passwordField.type === 'password') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>
                    }
                    @if (passwordField.type === 'text') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye-slash'"
                        ></mat-icon>
                    }
                </button> -->
                <mat-error> Password is required </mat-error>
            </mat-form-field>

            <!-- Password confirm field -->
            <mat-form-field class="mat-form-field-cleaner">
                <mat-label class="font-bold text-md">Repeat password</mat-label>
                <input
                    class="input"
                    id="password-confirm"
                    matInput
                    type="password"
                    [formControlName]="'passwordConfirm'"
                    #passwordConfirmField
                />
                <!-- <button
                    mat-icon-button
                    type="button"
                    (click)="
                        passwordConfirmField.type === 'password'
                            ? (passwordConfirmField.type = 'text')
                            : (passwordConfirmField.type = 'password')
                    "
                    matSuffix
                >
                    @if (passwordConfirmField.type === 'password') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>
                    }
                    @if (passwordConfirmField.type === 'text') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye-slash'"
                        ></mat-icon>
                    }
                </button> -->
                @if (
                    resetPasswordForm
                        .get('passwordConfirm')
                        .hasError('required')
                ) {
                    <mat-error>
                        Password confirmation is required
                    </mat-error>
                }
                @if (
                    resetPasswordForm
                        .get('passwordConfirm')
                        .hasError('mustMatch')
                ) {
                    <mat-error> Passwords must match </mat-error>
                }
            </mat-form-field>

            <!-- Countdown -->
            @if(isCountdown) {
                <div class="mt-0.5 flex justify-center font-medium">
                    <!-- Redirect countdown -->
                    @if (countdown > 0) {
                        Redirecting in
                        {{ countdown | i18nPlural: countdownMapping }}
                    }
    
                    <!-- Redirect message -->
                    @if (countdown === 0) {
                        You are now being redirected!
                    }
                </div>
    
                <!-- Form footer -->
                <div class="text-secondary mt-8 text-center text-md font-medium">
                    <span>Go to</span>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="['/sign-in']"
                        >sign in
                    </a>
                </div>
            }

            <!-- Submit button -->
            <!-- Hide the button once the countdown starts -->
            @if(!isCountdown) {
                <button
                    class="btn btn-primary btn-login mt-4"
                    [disabled]="resetPasswordForm.disabled"
                    (click)="resetPassword()"
                >
                    @if (!resetPasswordForm.disabled) {
                        <span class="flex-auto text-xl"> Reset Password </span>
                    }
                    @if (resetPasswordForm.disabled) {
                        <mat-progress-spinner
                            class="mx-auto"
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>
            }

        </form>  
    </div>
   
    <!-- Copyright -->
    <app-copyright></app-copyright>
</div>